import React, {useEffect, useState} from 'react';
import {Alert, Button, Card, Tag, Input} from "antd";
import {Shield} from "lucide-react";
import {useApiPostAdminDiscountDedicatesNotif, useApiUpdateAdminDiscountDedicates} from "@/api/discount";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import TextArea from "antd/lib/input/TextArea";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";
import {toast} from "react-toastify";
import RenderIf from "@/components/render-if";
import nl2br from "react-nl2br";

function DiscountDedicateSection({id, discountData, refetch}) {

    const [members, setMembers] = useState([])
    const [textNote, setTextNote] = useState('')
    const [textNoteNationalCode, setTextNoteNationalCode] = useState('')
    const [counter, setCounter] = useState({mobiles: 0, nationalCode: 0})
    const {
        mutate: updateDiscountDedicate,
        isPending: isPendingUpdateDiscountDedicate,
        isSuccess: isSuccessUpdateDiscountDedicate
    } = useApiUpdateAdminDiscountDedicates()

    const {
        mutate: sendNotif,
        isPending: isPendingSendNotif,
        isSuccess: isSuccessSendNotif
    } = useApiPostAdminDiscountDedicatesNotif()


    useEffect(() => {
        let myTextNote = "";
        let myTextNoteNationalCode = "";
        let countMobiles = 0
        let countNationalCode = 0
        if (discountData?.data?.data?.dedicates.length > 0) {
            setMembers(discountData.data?.data?.dedicates.map(item => item.useracademy_id));
            discountData.data?.data?.dedicates.map((item) => {
                if (item?.mobile) {
                    myTextNote += item.mobile + "\n"
                    countMobiles++;
                }

                if (item?.national_code) {
                    myTextNoteNationalCode += item.national_code + "\n"
                    countNationalCode++;
                }
            })
        }
        setTextNote(myTextNote);
        setTextNoteNationalCode(myTextNoteNationalCode);
        setCounter({mobiles: countMobiles, nationalCode: countNationalCode});

    }, [discountData])

    function onSave() {
        const dedicateData = {
            id: id,
            mobiles: textNote,
            national_codes: textNoteNationalCode
        }
        updateDiscountDedicate(dedicateData, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
                refetch?.()
            },
            onError: (r) => {
                ApiHandleErrorMessage(r)
            }
        })
    }

    function handleSendNotif() {
        sendNotif({id: id, send_notif: true}, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)

                if (r?.data?.data?.count) {
                    toast.info(` تعداد ${r?.data?.data?.count} پیامک ارسال شد . `)
                }


            },
            onError: (r) => {
                ApiHandleErrorMessage(r)
            }
        })
    }


    return (
        <div>
            <Card
                className="shadow-sm"
                title={
                    <div className="flex items-center gap-2">

                        <Shield size={20} className="text-gray-600"/>
                        <span>اختصاص به فرد خاص</span>
                    </div>
                }
            >
                <Alert message={'اختصاص کد تخفیف به فرد یا افراد خاص'} showIcon={true} type={'info'} description={<span>
                    <span>در این بخش می‌توانید کد تخفیف را به فرد یا افراد خاص اختصاص دهید. </span>
                    <br/>
                    دقت کنید که اولویت بررسی کد تخفیف ابتدا افراد است و سپس رویداد. یعنی اگر کد تخفیفی را برای یک  فرد خاص و در یک رویداد خاص تنظیم کند در این صورت تنها آن فرد و تنها در همان رویداد می‌تواند از این کد تخفیف استفاده کند.
                </span>}/>

                <div className="flex flex-col gap-2">
                    <div className={'mt-4 font-bold flex justify-between'}>
                        <div>اختصاص به موبایل افراد</div>
                        <div><Tag color={'green'}>{counter.mobiles} مورد </Tag></div>
                    </div>
                    <Input.TextArea placeHolder={'لطفا هر موبایل را در یک خط وارد کنید'}
                              rows={10}
                              dir={'ltr'}
                              value={textNote}
                              onChange={(value) => setTextNote(value?.target?.value)}
                    >

                    </Input.TextArea>
                </div>

                <div className="flex flex-col gap-2">
                    <div className={'mt-4 font-bold flex justify-between'}>
                        <div>اختصاص به کدملی افراد</div>
                        <div><Tag color={'green'}>{counter.nationalCode} مورد </Tag></div>
                    </div>
                    <Input.TextArea placeHolder={'لطفا هر کدملی را در یک خط وارد کنید'}
                              rows={10}
                              dir={'ltr'}
                              value={textNoteNationalCode}
                              onChange={(value) => setTextNoteNationalCode(value?.target?.value)}
                    >

                    </Input.TextArea>
                </div>
                <div className="text-sm text-gray-600 my-2">
                    توجه! موبایل‌ها و کدملی‌های نادرست به صورت خودکار از لیست حذف شده و موارد تکراری نیز تنها یک بار ثبت
                    خواهند شد.
                </div>
                {/*<TaggableSelect name={'user-search'}*/}
                {/*                className={'mt-2'}*/}
                {/*                label={'اختصاص به فرد خاص'}*/}
                {/*                searchFn={useApiSearchAdminMembers}*/}
                {/*                onChange={setMembers}*/}
                {/*                values={members}*/}
                {/*                render={(item) => {*/}
                {/*                    return toFaNumber(item.mobile) + ' - ' + item?.firstname + ' - ' + item?.lastname*/}
                {/*                }}></TaggableSelect>*/}
                <div className="flex">
                    <div className={'flex-1'}></div>
                    <div>
                        <Can permission={PermList.DISCOUNT_EDIT}>
                            <Button
                                loading={isPendingUpdateDiscountDedicate}
                                variant={'solid'}
                                color={'primary'}
                                className="mt-2"
                                onClick={onSave}>ذخیره</Button>

                        </Can>

                    </div>
                </div>

                <div className={'my-4'}>
                    <Alert
                        description={
                            <>
                                <div className="flex flex-wrap justify-between">
                                    <div>
                                        با زدن دکمه «ارسال پیامک» به تمام افرادی که مجاز به استفاده از این کد تخفیف
                                        هستند و کد ملی یا شماره موبایل آنها در لیست وجود دارد و تا کنون از این کد تخفیف
                                        استفاده نکرده اند و نیز پیامک اطلاع رسانی را هنوز دریافت نکرده اند، پیامک ارسال
                                        خواهد شد

                                        <div className="flex flex-col flex-wrap gap-2 ">
                                            متن پیامک اطلاع رسانی از بخش ویرایش اطلاعات اصلی کد تخفیف قابل تنظیم است
                                            <RenderIf condition={!!discountData?.data?.data?.notif_text}>
                                                <div className={'border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-800 p-1 rounded-lg'}>
                                                    {nl2br(discountData?.data?.data?.notif_text)}
                                                </div>
                                            </RenderIf>
                                        </div>

                                    </div>
                                    <div>

                                        <Button
                                            loading={isPendingSendNotif}
                                            onClick={handleSendNotif}
                                            type={'primary'}
                                            variant={'dashed'}
                                            color={'danger'}
                                        >ارسال پیامک</Button>
                                    </div>

                                </div>
                            </>
                        }
                        message={
                            <><span className={'font-bold'}>ارسال متن پیامک اطلاع رسانی به افراد</span></>
                        } type={'info'} showIcon={true}/>
                </div>

            </Card>

        </div>
    );
}

export default DiscountDedicateSection;